import { Link } from 'react-router-dom';
import { Permission } from '../../../store/GeneralStore';
import { Icon } from '../../Atoms/Icon';
import { TextSpan } from '../../Atoms/Text';
import { AddInventoryRouteState } from '../OutsideInventoryForm/addInventoryRouteState';
import { PermissibleRender } from '../PermissibleRender';

export interface AddInventoryLinkProps {
  state?: AddInventoryRouteState;
  dataCy: string;
}

/** The Add Inventory link, shown to a user who may add outside inventory; `state` seeds the manual form. */
export const AddInventoryLink = ({ state, dataCy }: AddInventoryLinkProps) => (
  <PermissibleRender requiredPermissions={[Permission.CREATE_OUTSIDE_INVENTORY]}>
    <Link
      role="link"
      title="Add Inventory"
      className="flex space-x-2 items-center"
      data-cy={dataCy}
      state={state}
      to="/add-inventory">
      <Icon
        type="plus"
        className="p-2"
      />
      <TextSpan
        color="grey12"
        size="sm14">
        Add Inventory
      </TextSpan>
    </Link>
  </PermissibleRender>
);
